import { CloudSharedEnvironment, CloudSharedProductionEnvironment } from "@smallstack/typesystem";

export const environment: CloudSharedEnvironment = {
  production: true,
  ...CloudSharedProductionEnvironment
};
